// extracted by mini-css-extract-plugin
module.exports = {"app":"components-AppContainer-AppContainer__app--1zlOg"};